// Objekte fürs Objekt-Dropdown der Listen (Mieter, Eigentümer) – SearchSelect, Knopf-Variante.
// Sortiert nach Objektnummer; Anzahl je Objekt liefert der jeweilige Bereich.

import { objektName, type ObjektKopfRoh } from './objektKopf';
import type { SucheOption } from './suche';

export interface ObjektOption extends SucheOption { sub: string; nummer: string; anzahl: number }

/** Gesucht wird über Name, Straße, Ort und Nummer (filtereInReihenfolge). */
export function objektOptionen(objekte: readonly ObjektKopfRoh[], anzahlJeObjekt: ReadonlyMap<string, number>): ObjektOption[] {
  const sortierer = new Intl.Collator('de', { numeric: true, sensitivity: 'base' });
  return objekte
    .map(o => {
      const ort = (o.stadt ?? '').trim() || (o.ort ?? '').trim();
      const nummer = (o.objektnummer ?? '').trim();
      const strasse = [o.strasse, o.hausnummer].map(s => (s ?? '').trim()).filter(Boolean).join(' ');
      return { id: o.id, label: objektName(o), sub: ort, nummer, anzahl: anzahlJeObjekt.get(o.id) ?? 0, suchtext: `${strasse} ${nummer}` };
    })
    .sort((a, b) => (a.nummer && b.nummer ? sortierer.compare(a.nummer, b.nummer) : a.nummer ? -1 : b.nummer ? 1 : 0) || sortierer.compare(a.label, b.label));
}
